export default __webpack_public_path__ + "media/images/49-9e5d2a8f91c3c4bd719d7bf52b15f19d.jpg";